import Repository from "@shared/services/api/abstracts/Repository";
import { AxiosRequestConfig } from "axios";
import { PublicBaseLocationPermissionsSerializer } from "../types/seating-types";

export default class PublicBasedTTLocationPermissionsRepository extends Repository<
  Array<PublicBaseLocationPermissionsSerializer>
> {
  public readonly repositoryName = "PublicBasedTTLocationPermissionsRepository";

  public readonly endpoint =
    "/api/public/events/ticket-types/location-permissions/";

  public async getPermissions(config: AxiosRequestConfig) {
    const { data } = await this.request(this.buildUrl(), config);
    return data;
  }
}
